import '@babel/polyfill';
import app from './client/app';

if (!window.glDBMTagReady) {
  window.glDBMTagReady = true;

  app();
}
